export default __webpack_public_path__ + "static/sanjayRakesh9-c6ed44e095f15527be9c0e55bc2d50d8.jpg";